import type { AllRouteEndpoints } from "../routeTypes";
export const generativeAiDalleAssistantCacheKeys: AllRouteEndpoints[] = ["/generative_ai/rate_limit_stats"];
